import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { getTypingMessageId } from '../../../redux/chat/selectors';
import MessageItem from './MessageItem';
import ChartMessage from './ChartMessage';
import BarChartMessage from './BarChartMessage';
import PieChartMessage from './PieChartMessage';
import MultiBarChartMessage from './MultiBarChartMessage';
import AreaChartMessage from './AreaChartMessage';
import StackedAreaChartMessage from './StackedAreaChartMessage';

const Messenger = ({
  messages = [],
}) => {
  Messenger.propTypes = {
    messages: PropTypes.arrayOf(PropTypes.shape({
      message: PropTypes.string,
      index: PropTypes.number,
      messageArray: PropTypes.arrayOf(PropTypes.shape({})),
    })),
  };

  Messenger.defaultProps = {
    messages: [],
  };
  const typingMessageId = useSelector(getTypingMessageId);
  return (
    <Fragment>
      {messages.map((message, index, messagesArray) => {
        const nextMessage = messagesArray[index + 1];
        const nextDate = nextMessage && nextMessage.created_at;
        const lastHumanMessage = (nextMessage && nextMessage.text) || '';
        return (
          <React.Fragment key={message.id || index}>
            <MessageItem
              key={message.id}
              id={message.id}
              isHuman={message.message_type === 'user'}
              nextDate={nextDate || null}
              isTypingMessage={typingMessageId === message.id}
              lastHumanMessage={lastHumanMessage}
              isMockHuman={message.id === 'mockHuman'}
              messageItem={message}
            />
            {Array.isArray(message.chart_data) && message.chart_data.length > 0 && (
              (() => {
                const { data: { chartType } } = message.chart_data[0];
                if (chartType === 'multiBar') {
                  return <MultiBarChartMessage key={`chart-${message.id || index}`} data={message.chart_data} />;
                }
                if (chartType === 'bar') {
                  return <BarChartMessage key={`chart-${message.id || index}`} data={message.chart_data} />;
                }
                if (chartType === 'pie') {
                  return <PieChartMessage key={`chart-${message.id || index}`} data={message.chart_data} />;
                }
                if (chartType === 'area') {
                  return <AreaChartMessage key={`chart-${message.id || index}`} data={message.chart_data} />;
                }
                if (chartType === 'stackedArea') {
                  return <StackedAreaChartMessage key={`chart-${message.id || index}`} data={message.chart_data} />;
                }
                return <ChartMessage key={`chart-${message.id || index}`} data={message.chart_data} />;
              })()
            )}
          </React.Fragment>
        );
      })}
    </Fragment>
  );
};

export default Messenger;
